import { Ticket, CheckCircle2 } from "lucide-react";
import { Drawer, Tag, Row, Col, Typography } from "antd";

const { Text, Paragraph } = Typography;
import dayjs from "dayjs";
import { STATUS_TAG } from "../HelpSupport.helpers";

function TicketDrawer({ ticket, onClose }) {
  if (!ticket) return null;
  const { data = {}, status, ticket_id, audit } = ticket;
  const tag = STATUS_TAG[status] ?? STATUS_TAG.OPEN;
  return (
    <Drawer
      open={!!ticket}
      onClose={onClose}
      title={
        <Row align="middle" gutter={8}>
          <Col flex="none">
            <Ticket className="h-4 w-4 text-primary" />
          </Col>
          <Col flex="auto">
            <Text strong>{data.subject ?? "Support Ticket"}</Text>
          </Col>
        </Row>
      }
      width={480}
    >
      <Row gutter={[0, 20]}>
        {/* Meta — status tag + ticket ID */}
        <Col span={24}>
          <Row justify="space-between" align="middle">
            <Col>
              <Tag
                color={tag.color}
                className="flex items-center gap-1 px-2 py-0.5 text-xs font-semibold uppercase"
              >
                {tag.icon} {status}
              </Tag>
            </Col>
            <Col>
              <Text type="secondary" className="text-xs">
                #{ticket_id}
              </Text>
            </Col>
          </Row>
        </Col>

        {/* Subject */}
        <Col span={24}>
          <Text
            type="secondary"
            className="text-xs font-semibold uppercase tracking-wide block mb-1"
          >
            Subject
          </Text>
          <Text strong>{data.subject}</Text>
        </Col>

        {/* Message */}
        <Col span={24}>
          <Text
            type="secondary"
            className="text-xs font-semibold uppercase tracking-wide block mb-1"
          >
            Your Message
          </Text>
          <Paragraph type="secondary" className="whitespace-pre-wrap mb-0">
            {data.body}
          </Paragraph>
        </Col>

        {/* Resolution — shown only when admin has responded */}
        {data.resolution && (
          <Col span={24}>
            <div className="rounded-xl border border-emerald-200 bg-emerald-50/50 p-4">
              <Row align="middle" gutter={6} className="mb-1">
                <Col flex="none">
                  <CheckCircle2 className="h-3.5 w-3.5 text-emerald-700" />
                </Col>
                <Col>
                  <Text
                    className="text-xs font-semibold uppercase tracking-wide text-emerald-700"
                  >
                    Admin Response
                  </Text>
                </Col>
              </Row>
              <Paragraph className="text-sm text-emerald-900 whitespace-pre-wrap mb-0">
                {data.resolution}
              </Paragraph>
            </div>
          </Col>
        )}

        {/* Audit */}
        <Col span={24} className="pt-4 border-t border-border/50">
          <Row gutter={[0, 4]}>
            {audit?.created_at && (
              <Col span={24}>
                <Text type="secondary" className="text-xs">
                  Raised:{" "}
                  {dayjs(audit.created_at).format("MMM D, YYYY [at] h:mm A")}
                  {audit.created_by && ` by ${audit.created_by}`}
                </Text>
              </Col>
            )}
            {audit?.updated_at && audit.updated_at !== audit.created_at && (
              <Col span={24}>
                <Text type="secondary" className="text-xs">
                  Last updated:{" "}
                  {dayjs(audit.updated_at).format("MMM D, YYYY [at] h:mm A")}
                  {audit.updated_by && ` by ${audit.updated_by}`}
                </Text>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Drawer>
  );
}

export default TicketDrawer;
